import { combineReducers } from "redux";
import * as api from "./api";

export default combineReducers({
  api: combineReducers({
    sendInvitation: api.sendInvitation.reducer,
    acceptInvitation: api.acceptInvitation.reducer,
    sendInsiderInvitation: api.sendInsiderInvitation.reducer,
    validateInsiderInvitation: api.validateInsiderInvitation.reducer
  })
});



// WEBPACK FOOTER //
// ./src/modules/referral/reducer.js